import { render, staticRenderFns } from "./UserDeleteAccount.vue?vue&type=template&id=2e833473"
import script from "./UserDeleteAccount.vue?vue&type=script&lang=js"
export * from "./UserDeleteAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports